export default (paginationQuery, searchQuery) => ({
  ...paginationQuery,
  ...(searchQuery || {})
});
